export default __webpack_public_path__ + "static/media/04AW2SEP66.76d9f9ef.jpg";